<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="状态：">
            <el-select
              v-model="query.isEnable"
              placeholder="请选择"
              clearable
              size="small"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="启用" :value="true"></el-option>
              <el-option label="禁用" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini"
              >搜索</el-button
            >
            <el-button type="info" @click="handleFilter" plain size="mini"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          
          <el-button
            type="primary"
            size="mini"
            @click="handleCreate"
            icon="el-icon-plus"
            >+ 新增</el-button
          >
          <div @click="handleBack" style="display: flex; align-items: center; cursor: pointer;">
            <img src="@/assets/back.png" alt="" style="width: 16px; height: 16px; margin-right: 4px;" />
            <span>返回</span>
          </div>
        </div>
      </div>
      <el-table 
        v-loading="listLoading" 
        :data="list"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" />
        <el-table-column label="序号" prop="id" align="center"  width="50">
          <template slot-scope="{ $index }">
            {{ (query.pageNo - 1) * query.pageSize + $index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="静态码" prop="qrcodeUrl" align="center">
          <template slot-scope="{ row }">
            <el-image
              v-if="row.qrcodeUrl"
              :src="row.qrcodeUrl"
              :preview-src-list="[row.qrcodeUrl]"
              style="width: 60px; height: 60px; cursor: pointer;"
              fit="cover"
            />
            <span v-else style="color: #999;">暂无</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="isEnable" align="center" >
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.isEnable"
              active-text="启用"
              inactive-text="禁用"
              :active-value="true"
              :inactive-value="false"
              @change="handleStateChange(row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          label="操作时间"
          prop="operatedTime"
          sortable="custom"
          align="center"
         
        />
        <el-table-column label="操作人" prop="operatedByName" align="center" />
        <el-table-column label="操作" align="center" fixed="right" >
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="handleEdit(row)"
              >编辑</el-button
            >
            <!-- <el-button
              type="text"
              @click="handleDelete(row)"
              style="color: #f56c6c;"
              >删除</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        :pageNo.sync="query.pageNo"
        :pageSize.sync="query.pageSize"
        @pagination="doQueryList"
      />
    </el-card>
    
    <!-- 新增/编辑对话框 -->
    <el-dialog 
      :title="form.id ? '编辑静态码' : '新增静态码'" 
      :visible.sync="formVisible" 
      :close-on-click-modal="false" 
      width="600px"
    >
      <el-form ref="dataForm" label-position="right" :rules="formRules" :model="form" size="small" label-width="120px">
        <el-form-item label="静态码图片" prop="qrcodeUrl" class="width100">
          <moreImageUpload
            v-model="form.qrcodeUrl"
            :limit="1"
          />
        </el-form-item>
        <el-form-item label="状态：" prop="isEnable">
          <el-switch 
            v-model="form.isEnable" 
            :active-value="true" 
            :inactive-value="false"
            active-text="启用"
            inactive-text="禁用"
          ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button type="primary" @click="doSubmit()" :loading="isLoading">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import cityCompanyQrcodeApi from "@/api/sys/cityCompanyQrcode";
import Pagination from "@/components/Pagination";
import MoreImageUpload from "@/components/MoreImageUpload";

export default {
  components: {
    Pagination,
    MoreImageUpload
  },
  props: {
    cityCompanyId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      selectItems: [],
      formVisible: false,
      isLoading: false,
      form: {
        id: null,
        cityCompanyId: null,
        qrcodeUrl: [],
        isEnable: true
      },
      formRules: {
        qrcodeUrl: [
          { 
            required: true, 
            message: '请上传静态码图片', 
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!value || (Array.isArray(value) && value.length === 0)) {
                callback(new Error('请上传静态码图片'));
              } else {
                callback();
              }
            }
          }
        ]
      },
      query: {
        pageNo: 1,
        pageSize: 20,
        cityCompanyId: null,
        isEnable: null
      }
    };
  },
  created() {
    // 从 props 或路由参数获取城市公司ID
    if (this.cityCompanyId) {
      this.query.cityCompanyId = parseInt(this.cityCompanyId);
    } else if (this.$route.query.cityCompanyId) {
      this.query.cityCompanyId = parseInt(this.$route.query.cityCompanyId);
    }
    this.doQueryList({
      pageNo: 1
    });
  },
  methods: {
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      });
    },
    /**
     * 重置搜索条件
     */
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 20,
        cityCompanyId: this.query.cityCompanyId, // 保留城市公司ID
        isEnable: null
      };
      this.doQueryList({
        pageNo: 1
      });
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo;
      }
      if (pageSize) {
        this.query.pageSize = pageSize;
      }
      let query = {
        ...this.query
      };
      // 清理空值
      if (query.isEnable === null || query.isEnable === '') {
        delete query.isEnable;
      }
      if (!query.cityCompanyId) {
        delete query.cityCompanyId;
      }
      this.listLoading = true;
      return cityCompanyQrcodeApi
        .fetchList(query)
        .then(({ data }) => {
          console.log("data: ", data);
          this.list = data.list || [];
          this.total = data.total || 0;
        })
        .catch(error => {
          console.error("查询失败: ", error);
          this.$message.error("查询失败，请稍后重试");
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 表格选择变化
     */
    handleSelectionChange(selection) {
      this.selectItems = selection;
    },
    /**
     * 批量删除
     */
    handleBatchDelete() {
      if (this.selectItems.length === 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除选中的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // TODO: 实现批量删除接口
          this.$message.success("批量删除功能待实现");
          // this.doQueryList({ pageNo: 1 });
        })
        .catch(() => {});
    },
    /**
     * 新增
     */
    handleCreate() {
      this.form = {
        id: null,
        cityCompanyId: this.query.cityCompanyId,
        qrcodeUrl: [],
        isEnable: true
      };
      this.formVisible = true;
      this.$nextTick(() => {
        this.$refs.dataForm && this.$refs.dataForm.clearValidate();
      });
    },
    /**
     * 编辑
     */
    handleEdit(row) {
      // 将字符串转换为数组格式（moreImageUpload 组件需要数组）
      let qrcodeUrlArray = [];
      if (row.qrcodeUrl) {
        // 如果是字符串，转换为数组格式
        if (typeof row.qrcodeUrl === 'string') {
          qrcodeUrlArray = [{
            url: row.qrcodeUrl,
            name: row.qrcodeUrl.split('/').pop() || 'qrcode.jpg',
            uid: Date.now()
          }];
        } else if (Array.isArray(row.qrcodeUrl)) {
          // 如果已经是数组，确保格式正确
          qrcodeUrlArray = row.qrcodeUrl.map((item, index) => {
            if (typeof item === 'string') {
              return {
                url: item,
                name: item.split('/').pop() || `qrcode-${index}.jpg`,
                uid: Date.now() + index
              };
            }
            return item;
          });
        }
      }
      
      this.form = {
        id: row.id,
        cityCompanyId: row.cityCompanyId,
        qrcodeUrl: qrcodeUrlArray,
        isEnable: row.isEnable
      };
      this.formVisible = true;
      this.$nextTick(() => {
        this.$refs.dataForm && this.$refs.dataForm.clearValidate();
      });
    },
    /**
     * 提交表单（新增/编辑）
     */
    doSubmit() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.isLoading = true;
          const apiMethod = this.form.id ? cityCompanyQrcodeApi.update : cityCompanyQrcodeApi.create;
          const data = {
            ...this.form
          };
          
          // 将数组转换为字符串（取第一个图片的 URL）
          if (Array.isArray(data.qrcodeUrl) && data.qrcodeUrl.length > 0) {
            // moreImageUpload 返回的是对象数组，取 url 字段
            const firstImage = data.qrcodeUrl[0];
            data.qrcodeUrl = typeof firstImage === 'string' ? firstImage : (firstImage.url || '');
          } else {
            data.qrcodeUrl = '';
          }
          
          apiMethod(data)
            .then(() => {
              this.$message.success(this.form.id ? '修改成功' : '新增成功');
              this.formVisible = false;
              this.doQueryList({ pageNo: 1 });
            })
            .catch(error => {
              console.error('操作失败: ', error);
              this.$message.error('操作失败，请稍后重试');
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      });
    },
    /**
     * 修改状态
     */
    handleStateChange(row) {
      cityCompanyQrcodeApi.setEnable({
        id: row.id,
        isEnable: row.isEnable
      })
        .then(() => {
          this.$message.success('状态修改成功');
        })
        .catch(error => {
          // 如果失败，恢复原状态
          row.isEnable = !row.isEnable;
          console.error('状态修改失败: ', error);
          this.$message.error('状态修改失败，请稍后重试');
        });
    },
    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("确认删除该条数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // TODO: 实现删除接口
          this.$message.success("删除功能待实现");
          // this.doQueryList({ pageNo: 1 });
        })
        .catch(() => {});
    },
    /**
     * 返回上一页
     */
    handleBack() {
      this.$emit('handleShow', '', 1);
    }
  }
};
</script>

<style scoped>
.mt10 {
  margin-top: 10px;
}
.mb10 {
  margin-bottom: 10px;
}
.btn-right-side {
  display: flex;
  justify-content: flex-end;
}
.btn-box {
  display: flex;
  gap: 10px;
}
.fr {
  float: right;
}
</style>

